import { TEMPLATE_TYPES } from "@papier/templates-contracts";
import { zodSlug } from "@papier/shared";
import { z } from "zod";

export const templateSearchSchema = z.object({
  env: zodSlug().optional(),
  q: z.string().optional(),
  type: z.enum(TEMPLATE_TYPES).optional().catch(undefined),
  status: z.enum(["draft", "published"]).optional().catch(undefined),
  sort: z.enum(["updated", "name"]).optional().catch(undefined),
});
